<script setup lang="ts">
const { open, color, text } = storeToRefs(useNotify())
</script>

<template>
  <v-snackbar v-model="open" :color="color" :timeout="10000">{{ text }}<template v-slot:actions>
      <v-btn @click="open = false" icon="mdi-close" size="x-small" />
    </template>
  </v-snackbar>
</template>
